import React from 'react';
import PropTypes from 'prop-types';

import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  Container,
  Content,
  Text,
  Title,
} from './styles';

const ConfirmModal = (props) => {
  /** props */
  const {
    active,
    onClose,
    onSubmit,
    isMoving,
  } = props;

  return (
    <Container
      active={active}
      onClickOutside={onClose}
      page
    >
      <Content>
        <Title>
          {`Are you sure you want to ${isMoving ? 'move' : 'delete'} this page?`}
        </Title>

        {isMoving ? (
          <Text>
            If you move this page, all skip logic statements related to this page will be pointed&nbsp;
            to the end screen (end of study)
          </Text>
        ) : (
          <>
            <Text>
              All questions on this page will be deleted.
            </Text>

            <Text>
              Any skip logic that is pointing to this page will now be pointing to the end screen (end of study).
            </Text>
          </>
        )}

        <ButtonContainer>
          <CancelButton
            onClick={onClose}
          >
            Cancel
          </CancelButton>

          <ConfirmButton
            onClick={onSubmit}
          >
            {`${isMoving ? 'Move' : 'Delete'} page`}
          </ConfirmButton>
        </ButtonContainer>
      </Content>
    </Container>
  );
};

ConfirmModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isMoving: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  isMoving: false,
};

export default ConfirmModal;
